import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/endpoints';
import PageHeader from '../../components/PageHeader';
import { JobCard } from '../../components/Cards';
import { Empty, Loading } from '../../components/Ui';
import { Reveal, stagger } from '../../components/Motion';

/** Jobs the person bookmarked from the jobs list, to apply to later. */
const SavedJobsPage = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    api.jobs.saved()
      .then((r) => setJobs(r.data || []))
      .catch(() => setJobs([]))
      .finally(() => setLoading(false));
  }, []);
  useEffect(load, [load]);

  const unsave = async (job) => {
    setJobs((list) => list.filter((j) => j._id !== job._id));
    try {
      await api.jobs.toggleSaved(job._id);
    } catch (e) {
      load();
    }
  };

  return (
    <div>
      <PageHeader title="Saved jobs" subtitle={`${jobs.length} kept for later`} />

      {loading ? <Loading /> : !jobs.length ? (
        <Empty
          emoji="🔖"
          title="No saved jobs"
          text="Use the bookmark on any job to keep it here and apply when you are ready."
        />
      ) : (
        <div className="grid grid-cards">
          {jobs.map((job, i) => (
            <Reveal key={job._id} delay={stagger(i, 45)}>
              <JobCard job={job} saved onToggleSave={() => unsave(job)} onClick={() => navigate(`/jobs/${job._id}`)} />
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
};

export default SavedJobsPage;
